import { render, staticRenderFns } from "./StepFinish.vue?vue&type=template&id=508f2ddc&scoped=true"
import script from "./StepFinish.vue?vue&type=script&lang=ts"
export * from "./StepFinish.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f2ddc",
  null
  
)

export default component.exports